import { defineMessages } from "react-intl";
const messages = defineMessages({
    ariaLabel: {
        id: "app.aiDiscoverability.common.downloadReportButton.ariaLabel",
        defaultMessage: "Download reports",
    },
    exportInProgress: {
        id: "app.aiDiscoverability.common.downloadReportButton.exportInProgress",
        defaultMessage: "An export is already in progress",
    },
    portfolioScope: {
        id: "app.aiDiscoverability.common.downloadReportButton.portfolioScope",
        defaultMessage: "All data will be exported from each community's Most Recent report",
    },
    portfolioDisabled: {
        id: "app.aiDiscoverability.common.downloadReportButton.portfolioDisabled",
        defaultMessage: "No community has a completed report to export yet",
    },
    communityScope: {
        id: "app.aiDiscoverability.common.downloadReportButton.communityScope",
        defaultMessage: "All data will be exported from this community's most recent report",
    },
    communityDisabled: {
        id: "app.aiDiscoverability.common.downloadReportButton.communityDisabled",
        defaultMessage: "No completed report to export yet",
    },
    reportScope: {
        id: "app.aiDiscoverability.common.downloadReportButton.reportScope",
        defaultMessage: "All data will be exported from the report version on screen",
    },
    reportDisabled: {
        id: "app.aiDiscoverability.common.downloadReportButton.reportDisabled",
        defaultMessage: "Report is still being generated",
    },
});
export default messages;
